import type { ResponseConfig } from "@memorang/types";
import { getAllowAudioReplay } from "./response-timing";

export type AudioGatePlan = {
	audioAutoPlays: boolean;
	ttsAutoPlay: boolean;
	ttsPlayOnce: boolean;
	forceCompleted: boolean;
	nothingPlays: boolean;
	playOnce: boolean;
};

// With autoPlayChildAudio, shared audio autoplays only on the set's first item; others skip to TTS. Otherwise, autoPlayAudio controls per-item autoplay without TTS.
export const resolveAudioGatePlan = ({
	config,
	hasAudio,
	isFirstStimulusItem,
	ttsStem,
	isActiveSummative,
}: {
	config?: ResponseConfig;
	hasAudio: boolean;
	isFirstStimulusItem: boolean;
	ttsStem?: string;
	isActiveSummative: boolean;
}): AudioGatePlan => {
	const gated = Boolean(config) && hasAudio;

	// Set-level autoplay applies only for active summative sessions.
	const autoPlayChild =
		Boolean(config?.autoPlayChildAudio) && isActiveSummative;

	const allowReplay = Boolean(getAllowAudioReplay(config, isActiveSummative));

	const audioAutoPlays = autoPlayChild
		? gated && isFirstStimulusItem
		: gated && Boolean(config?.autoPlayAudio);

	const ttsAutoPlay = autoPlayChild && Boolean(ttsStem?.trim());

	return {
		audioAutoPlays,
		ttsAutoPlay,
		ttsPlayOnce: ttsAutoPlay && !allowReplay,
		forceCompleted:
			autoPlayChild && hasAudio && !isFirstStimulusItem && !allowReplay,
		nothingPlays: autoPlayChild && !(audioAutoPlays || ttsAutoPlay),
		playOnce: config ? !allowReplay : false,
	};
};
